export default class Meta {

    static NEW = new this({
        show: false
    })

    constructor({
                    title, subGroup,
                    icon, btnName, showChild, middleware,
                    appendBtn = false,
                    active = false,
                    show = true, permissions = null
                }) {
        this.title = title
        this.subGroup = subGroup
        this.active = active
        this.icon = icon
        this.appendBtn = appendBtn
        this.btnName = btnName
        this.showChild = showChild
        this.middleware = middleware
        this.show = show
        this.permissions = permissions
    }

    static instance({
                        title = '',
                        subGroup = false,
                        icon = '',
                        btnName = '',
                        active = false,
                        show = true,
                        appendBtn = false,
                        showChild = null,
                        middleware = null,
                        permissions = null
                    }
    ) {

        return new this({title, active, subGroup, icon, btnName, appendBtn, show, permissions, showChild, middleware})
    }
}
